import { Box } from "@mui/material";
import { ReactNode } from "react";
import { styled } from "@mui/material/styles";

const LayoutRoot = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    minHeight: '100vh'
}));

const LayoutContent = styled(Box)(({ theme }) => ({
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    position: 'relative',
    WebkitOverflowScrolling: 'touch',
}));

const AuthenticationLayout = ({ children }: { children: ReactNode }) => {
    return (
        <LayoutRoot id="layout-root">
            <LayoutContent id="layout-content">
                {children}
            </LayoutContent>
        </LayoutRoot>
    );
};

export default AuthenticationLayout;